import { v4 as uuidv4 } from "uuid";

// Identifies this browsing context for the lifetime of the page load. Sent with
// every internal API call as `X-Client-Id` and echoed back on the cable, so a
// subscriber can tell its own round trip apart from another session's — which a
// user id cannot do when one account is open in several tabs or shared by a team.
export const CLIENT_ID = uuidv4();
